export default __webpack_public_path__ + "static/media/Run_Health.cba4b0da.png";